import apiService from './api';

interface DashboardStatsResponse {
  count: number;
}

interface TodayStatsResponse {
  total: number;
  completed: number;
}

const dashboardService = {
  getActivePatientsCount: async (): Promise<number> => {
    const response = await apiService.get<DashboardStatsResponse>('/api/person/count/active');
    return response.data?.count || 0;
  },

  getTodayAppointmentsStats: async (): Promise<TodayStatsResponse> => {
    const response = await apiService.get<TodayStatsResponse>('/api/appointment/today-stats');
    return response.data || { total: 0, completed: 0 };
  },
};

export default dashboardService;
